<template>
    <div class="optpl-filter-groups">
        <div class="optpl-filter-group">
            <h3>
                <a href="#">
                    <span>Sort by</span>
                </a>
            </h3>

            <div class="optpl-filter-group__filters">
                <select class="opui-form-control" v-model="this.filtersStore.sortBy" @change="$emit('filter')">
                    <option v-for="option in filtersStore.sortOptions" :value="option.value">{{ option.label }}</option>
                </select>
            </div>
        </div>

        <FilterGroup @filter="filter" v-for="group in groups" :group="group" />

        <div class="optpl-filter-groups__disabled-overlay" v-if="templatesStore.loading"></div>
    </div>
</template>

<script>
import FilterGroup from './FilterGroup.vue'
import { useFiltersStore } from "../../store/filters"
import { useTemplatesStore } from "../../store/templates"
import { mapStores } from 'pinia'

export default {
    components: { FilterGroup },
    data() {
        return {
            filtersHidden: false,
        }
    },
    computed: {
        ...mapStores(useFiltersStore, useTemplatesStore),
    },
    props: {
        groups: { type: Array, required: true },
    },
    methods: {
        filter() {
            this.$emit('filter')
        },

        hideFilters() {
            this.filtersHidden = true
            this.$events.emit('hide')
        },

        showFilters() {
            this.filtersHidden = false
            this.$events.emit('show')
        },

        resetFilters() {
            this.$emit('reset')
        },
    }
}
</script>
